/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NycProfileStatus } from './nyc-profile-status';


/**
 * Just enough to follow a re-registration attempt while it runs, as its own route rather than a widening of `UserDto`: this is polled every few seconds, and `getUser` reads six repositories, writes an audit entry and returns the user\'s whole history. `autoCreateStatus` is not on `UserDto` at all today -- only on the registration *list* rows -- so a per-user page had nowhere to read it.  Terminal states, from the poller\'s point of view: `status` moving off `not-created` (the registration went through), or `autoCreateStatus` reaching `failed`.
 */
export interface RegistrationProgressDto { 
    status: NycProfileStatus;
    autoCreateStatus: RegistrationProgressDto.AutoCreateStatusEnum;
    autoCreateFailureReason?: string;
}
export namespace RegistrationProgressDto {
    export const AutoCreateStatusEnum = {
        pending: 'pending',
        in_progress: 'in-progress',
        failed: 'failed'
    } as const;
    export type AutoCreateStatusEnum = typeof AutoCreateStatusEnum[keyof typeof AutoCreateStatusEnum];
}


